import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteGroupDialogContentComponent } from './delete-group-dialog-content/delete-group-dialog-content.component';

@Component({
  selector: 'app-delete-group-dialog',
  template: ''
})
export class DeleteGroupDialogComponent implements OnInit {

  private groupId: number;

  constructor(public dialog: NgbModal, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.groupId = Number.parseInt(params.get('key'));
      this.openDialog();
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DeleteGroupDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.groupId = this.groupId;

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    });
  }

}
